import Arrow from 'components/Icons/Arrow'
import Input from 'components/Input'
import React, { useEffect, useState } from 'react'
import useInnerPage from 'store/InnerPageProvider'
import { CheckboxInputs, FilterBlock } from 'style/Category.style'

export default function SingleFilter(props) {
  const { attr } = props
  const { params, setParam } = useInnerPage()
  const [open, setOpen] = useState(false)
  const [values] = useState(attr.values || [])
  const [filtereds, setFiltereds] = useState(params.attrs[attr.id] || [])

  const openToggle = () => {
    setOpen(!open)
  }

  useEffect(() => {
    setFiltereds(params.attrs[attr.id] || [])
    // eslint-disable-next-line
  }, [params.attrs[attr.id]])

  const handleChange = e => {
    const checked = e.target?.checked
    const val = e.target?.value
    if (!val) return
    setFiltereds(old => {
      checked ? old.push(val) : old.splice(old.indexOf(val), 1)
      return [...old]
    })
    setParam(attr.id, filtereds, 'attrs')
  }

  return (
    <FilterBlock key={attr.name}>
      <h3>{attr.name || ''}</h3>
      <CheckboxInputs
        className={`checkboxes ${open ? 'active' : ''} ${
          values.length < 5 ? 'overflow-visible' : ''
        }`}
      >
        {filtereds.map(val => {
          return (
            <Input
              key={`f_${val}`}
              component="checkbox"
              value={val}
              defaultChecked
              onChange={handleChange}
              title={val}
            />
          )
        })}
        {values.map(val => {
          if (filtereds.indexOf(val) > -1) return null
          return (
            <Input
              key={val}
              component="checkbox"
              value={val}
              onChange={handleChange}
              title={val}
            />
          )
        })}
      </CheckboxInputs>
      {values.length > 4 && (
        <p onClick={openToggle}>
          {open ? 'დახურვა' : 'მეტის ჩვენება'}
          <Arrow color="black2" direction={open ? 'top' : 'bottom'} />
        </p>
      )}
    </FilterBlock>
  )
}
